import Contact from '../components/Contact';
import { Box } from '@mui/material';

const ContactPage = () => {
  return (
    <Box sx={{ pt: { xs: 5, md: 6 } }}>
      <Contact />
    </Box>
  );
};

export default ContactPage;
